import React from 'react';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import ModalCloseIcon from '@/components/general/ModalCloseIcon/ModalCloseIcon';
import { FlexContainer } from '@/components/containers/FlexContainer/FlexContainer';
import Label from '@/components/form/Label/Label';

const errorStyle = {
  color: 'red',
  fontSize: '10px',
  marginTop: '2px',
  marginLeft: '12px',
  fontWeight: '600',
};

const AgendaCitaFacturacionModal = ({
  open,
  onClose,
  onConfirm,
  onConfirm2,
  validationSchemaFacturacion,
  saveMedicalHistory,
  selectedDoctor,
  selectedSchedule,
  returnMedicalHistoryForPay,
  setJsonToPay,
}) => {
  if (!open) return null;

  return (
    <FlexContainer
      className={'pos-fixed justify-center align-items-center'}
      style={{
        inset: 0,
        background: 'rgba(0,0,0,0.45)',
        zIndex: 9999,
      }}
    >
      <FlexContainer
        className={'pos-rel flex-column align-center width-600px m-format75 padtb36 padlr36 height-640px'}
        style={{
          background: '#ffffff',
          borderRadius: '6px',
          boxShadow: '0px 5px 18px rgba(0,0,0,0.18)',
        }}
      >
        <FlexContainer
          onClick={onClose}
          className={
            'pos-abs top20 right20 pointer width-34px height-34px align-items-center justify-center text-18 fontWhite'
          }
          style={{
            borderRadius: '50%',
            background: '#023B7A',
            fontWeight: '900',
            boxShadow: '0px 2px 5px rgba(2, 59, 122, 0.3)',
          }}
        >
          <ModalCloseIcon />
        </FlexContainer>

        <div
          className={
            'width-520px m-format100 height-520px bgWhite borderrad20 padtb20 padlr12 m-padlr0 pos-rel top20 margb20 left30 m-left0'
          }
        >
          <Formik
            initialValues={{
              documentType: 'DNI',
              documentNumber: '',
              fullName: '',
              submitAction: '',
            }}
            validationSchema={validationSchemaFacturacion}
            onSubmit={(values) => {
              if (values.submitAction === 'CONFIRMAR') {
                const jsonToPay = returnMedicalHistoryForPay(selectedDoctor, selectedSchedule, values);
                setJsonToPay(jsonToPay);
                onConfirm && onConfirm(values);
              }

              if (values.submitAction === 'RESERVAR') {
                saveMedicalHistory(selectedDoctor, selectedSchedule, values);
                onConfirm2 && onConfirm2(values);
              }
            }}
          >
            {({ handleSubmit, setFieldValue, errors, touched }) => (
              <Form onSubmit={handleSubmit}>
                <FlexContainer className="flex-column gap-14 padlr12">
                  <Label className="text-16 fontBold" style={{ color: '#023B7A' }}>
                    Datos de Facturación
                  </Label>

                  <Label className="text-12 margb12" style={{ color: '#6b6b6b' }}>
                    * En caso de desear gestionar reembolso, deberá ingresar el RUC y Razón Social
                    de su Aseguradora.
                  </Label>

                  <FlexContainer className="pos-rel">
                    <Label
                      className="pos-abs text-11 padlr6"
                      style={{
                        top: '-8px',
                        left: '12px',
                        background: '#fff',
                        color: '#144796',
                        fontWeight: 600,
                      }}
                    >
                      Seleccione el tipo de documento*
                    </Label>

                    <Field
                      as="select"
                      name="documentType"
                      className="width100 height-40px padl12 padr40px text-14 borderrad6"
                      style={{
                        border: '2px solid #144796',
                        color: '#144796',

                        appearance: 'none',
                      }}
                    >
                      <option value="DNI">D.N.I.</option>
                      <option value="CARNET">Carnet de extranjeria</option>
                      <option value="PASAPORTE">Pasaporte</option>
                      <option value="RUC">R.U.C.</option>
                      <option value="OTROS">Otros</option>
                    </Field>

                    <span
                      className="pos-abs right12 pointerEventsNone"
                      style={{
                        top: '50%',
                        transform: 'translateY(-50%) rotate(270deg)',
                        fontSize: 22,
                        fontWeight: 900,
                        color: '#144796',
                      }}
                    >
                      ‹
                    </span>
                  </FlexContainer>

                  <FlexContainer className="pos-rel flex-column">
                    <Label
                      className="pos-abs text-11 padlr6"
                      style={{
                        top: '-8px',
                        left: '12px',
                        background: '#fff',
                        color: '#144796',
                        fontWeight: 600,
                      }}
                    >
                      Ingrese número de documento para comprobante*
                    </Label>

                    <Field
                      name="documentNumber"
                      className=" height-40px padl12 text-14 borderrad6"
                      style={{
                        border:
                          touched.documentNumber && errors.documentNumber
                            ? '2px solid red'
                            : '2px solid #144796',
                      }}
                    />
                    <ErrorMessage name="documentNumber" component="div" style={errorStyle} />
                  </FlexContainer>

                  <FlexContainer className="pos-rel flex-column">
                    <Label
                      className="pos-abs text-11 padlr6"
                      style={{
                        top: '-8px',
                        left: '12px',
                        background: '#fff',
                        color: '#144796',
                        fontWeight: 600,
                      }}
                    >
                      Nombre Completo o Razón Social*
                    </Label>

                    <Field
                      name="fullName"
                      className=" height-40px padl12 text-14 borderrad6"
                      style={{
                        border:
                          touched.fullName && errors.fullName
                            ? '2px solid red'
                            : '2px solid #144796',
                      }}
                    />
                    <ErrorMessage name="fullName" component="div" style={errorStyle} />
                  </FlexContainer>


                  <ul className={'text-12 m-text-8'} style={{ margin: 0, paddingLeft: 16, color: '#023B7A' }}>
                  <li style={{fontWeight: 'bold', backgroundColor: '#FFF3CD', padding: '8px 10px', borderRadius: '6px', marginBottom: '8px', listStyle: 'none', marginLeft: '-16px' }}
                  >
                    La cita reservada debe pagarse al momento de la reserva o, como máximo, 48 horas
                    antes de la cita. De lo contrario, será cancelada por falta de pago.
                  </li>
                  <li>
                    Las cancelaciones o reprogramaciones con menos de 48 h de anticipación tendrán
                    una penalidad de S/50.
                  </li>
                  <li>
                    Si cuenta con resultados médicos, envíelos a{' '}
                    <strong>archivos@drq.com.pe</strong> 48 h antes.
                  </li>
                  <li>Se recomienda llegar con 10 minutos de anticipación.</li>
                  <li>La reserva de la cita implica el pago total de la misma.</li>
                  <li>Si desea generar un reembolso con su aseguradora, ingrese el RUC y la Razón
                    Social de la aseguradora.</li>
                </ul>

                  <button
                    type="submit"
                    onClick={() => setFieldValue('submitAction', 'CONFIRMAR')}
                    className="height-40 borderrad8 pointer margt10 pad10"
                    style={{
                      background: '#023B7A',
                      color: '#ffffff',
                      fontWeight: 700,
                      border: 'none',
                    }}
                  >
                    CONFIRMAR RESERVA Y PROCEDER AL PAGO
                  </button>

                  <button
                    type="submit"
                    onClick={() => setFieldValue('submitAction', 'RESERVAR')}
                    className="height-40 borderrad8 pointer  pad10"
                    style={{
                      background: '#023B7A',
                      color: '#ffffff',
                      fontWeight: 700,
                      border: 'none',
                    }}
                  >
                    RESERVAR Y PAGAR DESPUES
                  </button>

                  <button
                    type="button"
                    onClick={onClose}
                    className="height-40 borderrad8 pointer pad10"
                    style={{
                      background: '#6f8ec0',
                      color: '#023B7A',
                      fontWeight: 700,
                      border: '1px solid #3b54a5',
                    }}
                  >
                    ← IR ATRÁS
                  </button>
                </FlexContainer>
              </Form>
            )}
          </Formik>
        </div>
      </FlexContainer>
    </FlexContainer>
  );
};

export default AgendaCitaFacturacionModal;
